<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-piece">
        <div class="h-formBox width">
          <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="年份" prop="GJAHR">
                <el-select v-model="formInline.GJAHR"  filterable :placeholder="'--选择--'" clearable>
                  <el-option v-for="item in this.yearList"
                             :key="item.valut"
                             :label="item.name"
                             :value="item.valut">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="月份" prop="months">
                <el-select v-model="formInline.months"  filterable :placeholder="'--选择--'" clearable>
                  <el-option v-for="item in this.monthList"
                             :key="item.valut"
                             :label="item.name"
                             :value="item.valut">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="公司" prop="BUKRS">
                <el-select v-model="formInline.BUKRS"  filterable :placeholder="'--选择--'" clearable>
                  <el-option v-for="item in this.gongsiList"
                             :key="item.code"
                             :label="[item.code] + item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户名称">
                <el-input v-model="formInline.receUsername" placeholder="模糊查询" clearable></el-input>
              </el-form-item>
              <el-form-item label="客户编号">
                <el-input v-model="formInline.receUsercode" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </div>
          </el-form>
          <div class="l-screenBox">
            <div class="l-retrieval">
              <el-button class="h-btn h-formBtn" @click="searchReset">检索</el-button>
              <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="h-table h-mrt30 tableclslist">
        <el-table ref="ddtable" :data="tableData" border
            :show-overflow-tooltip="true"
            :summary-method="getSummaries"
            show-summary
            style="width: 100%"
            max-height="450">
          <el-table-column type="index" width="60" label="#"></el-table-column>
          <el-table-column prop="bukrs" label="公司" width="220" :show-overflow-tooltip="true" >
            <template slot-scope="scope">
              <dictname category="xiaoshou_zuzhi" :v="scope.row.bukrs"/>
            </template>
          </el-table-column>
          <el-table-column prop="gjahr" label="年度" :show-overflow-tooltip="true" width="80"></el-table-column>
          <el-table-column prop="months" label="月度" :show-overflow-tooltip="true" width="80">
            <template slot-scope="scope">
              {{monthList.filter(f => f.valut == scope.row.months)[0].name}}
            </template>
          </el-table-column>
          <el-table-column prop="receUsername" label="客户名称" :show-overflow-tooltip="true" width="220" ></el-table-column>
          <el-table-column prop="receUsercode" label="客户编码" :show-overflow-tooltip="true" width="180" ></el-table-column>
          <el-table-column prop="customerType" label="客户类型" :show-overflow-tooltip="true" width="100" ></el-table-column>
          <el-table-column prop="totalprice" label="回款金额" :show-overflow-tooltip="true" ></el-table-column>
          <el-table-column prop="waers" label="货币类型" :show-overflow-tooltip="true" ></el-table-column>
          <el-table-column label="操作" :show-overflow-tooltip="true" >
            <template slot-scope="scope">
              <el-button
                  size="small" class="h-tableLink h-btn"
                  @click="seeDetail(scope.row)">查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
          <pagination :page="formInline" @query="searchReset"/>
          <div style="display:flex;align-items: center;">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel()">批量导出
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ss from "@/api/SystemService";
  import updownfile from "@/utils/updownfile";
  export default {
    components: {updownfile},
    data() {
      return {
        //表单
        formInline: {
          //月份
          months: null,
          //销售组织
          BUKRS: null,
          //客户编码
          receUsercode: null,
          //客户名称
          receUsername: null,
          //年度
          GJAHR:null,
          total: 0,
          pageSize: 10,
          pageNo: 1
        },
        monthList:[
          {valut:'01',name:'一月'},
          {valut:'02',name:'二月'},
          {valut:'03',name:'三月'},
          {valut:'04',name:'四月'},
          {valut:'05',name:'五月'},
          {valut:'06',name:'六月'},
          {valut:'07',name:'七月'},
          {valut:'08',name:'八月'},
          {valut:'09',name:'九月'},
          {valut:'10',name:'十月'},
          {valut:'11',name:'十一月'},
          {valut:'12',name:'十二月'},
        ],
        yearList:[
          {valut:'2027',name:'2027'},
          {valut:'2026',name:'2026'},
          {valut:'2025',name:'2025'},
          {valut:'2024',name:'2024'},
          {valut:'2023',name:'2023'},
        ],
        gongsiList:[],
        tableData:[],
      }
    },
    created() {
      const date = new Date();
      let currentMonth = date.getMonth() + 1; // 注意月份是从0开始计数，所以需要加1
      let currentYear = date.getFullYear();
      console.log(currentYear)
      if (currentMonth < 10){
        currentMonth = '0' + currentMonth;
      }
      console.log(currentMonth);
      this.formInline.months = currentMonth;
      this.formInline.GJAHR = currentYear;
      ss.salesList.getUserAuth().then(response => {
        this.gongsiList = response;
      });
      this.searchReset();
    },
    methods: {
      //查询数据
      searchReset(){
        ss.salesList.selectCountPage(this.formInline).then(response => {
          this.tableData = response.records;
          this.formInline.total = response.total;
        })
      },
      //重置查询条件
      resetData(){
        const date = new Date();
        let currentMonth = date.getMonth() + 1; // 注意月份是从0开始计数，所以需要加1
        let currentYear = date.getFullYear();
        if (currentMonth < 10){
          currentMonth = '0' + currentMonth;
        }
        this.formInline.months = currentMonth;
        this.formInline.GJAHR = currentYear;
        this.formInline.BUKRS = null;
        this.formInline.receUsercode = null;
        this.formInline.receUsername = null;
      },
      //查看详情按钮功能
      seeDetail(v) {
        var url = this.$router.resolve({path: '/payment-details',
          query:{bukrs: v.bukrs, receUsercode: v.receUsercode, months: v.months, gjahr: v.gjahr,customerType:v.customerType}});
        window.open(url.href, "_blank");
      },
      //导出
      exportExcel(){
        updownfile.down("/api/swyl/v1/domestic/userReceDomestic/exportExcel",this.formInline,"post",'sata');
      },
      getSummaries(param){
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          console.log(column,index)
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[1] = '';
            sums[2] = '';
            sums[3] = '';
            sums[4] = '';
            sums[5] = '';
            sums[6] = '';
            sums[8] = '';
          }
        });
        return sums;
      },
    }
  }
</script>

<style>

</style>
